import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Commissionutilization() {

        const [agent, setAgent] = useState('')
        const [agentCode, setAgentcode] = useState('')
        const [extensions, setExtensions] = useState([])
        const [currentPage, setCurrentPage] = useState(1);
        const rowsPerPage = 20;
        const totalPages = Math.ceil(extensions.length / rowsPerPage);
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
        const [monthStartMs, setMonthstartms] = useState(null)
        const[end,setEnd] = useState('');
        const[start,setStart] = useState('');
        const[utilizedCommission, setUtilizedcommission] = useState(0)
        const [availableCommission, setAvailablecommission] = useState(0)
        const [currentMonthName,setCurrentmonthname] = useState(null)
        const [credentials, setCredentials] = useState(null)
        const [isAuth, setIsauth] = useState(false)
        const company = 'Definite'
    
        useEffect(()=>{
        const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
        }
        getCredentials()
    
        },[])

        const handleDateChange = (e) => {
            const dateTime = e.target.value;
            const millisecondsSinceEpoch = new Date(dateTime).getTime();
            setStart(millisecondsSinceEpoch);
            const date = new Date(millisecondsSinceEpoch);

            const monthName = date.toLocaleString('default', { month: 'long' });
            setCurrentmonthname(monthName)
        
          };
          const handleDateChange2 = (e) => {
            const dateTime = e.target.value;
            const millisecondsSinceEpoch = new Date(dateTime).getTime();
            setEnd(millisecondsSinceEpoch);
           
          };
 
        const exportTableToPDF = () => {
            const input = document.getElementById('policy-table');
            
            // Optional: Add a temporary title to the table before capturing
            const title = document.createElement('h2');
            title.textContent = `${currentMonthName} COMMISSION UTILIZATION REPORT`;
            title.style.textAlign = 'center';
            title.style.color = '#2c3e50';

            title.style.marginBottom = '20px';
            input.parentNode.insertBefore(title, input); // Insert title above table
          
            // Color the header row (if not already styled)
            const headerRow = input.querySelector('thead tr');
            headerRow.style.backgroundColor = 'green'; // Dark gray
            headerRow.style.color = 'white';
          
            html2canvas(input, {
              scale: 2, // Higher quality
              logging: false, // Disable console logs
              useCORS: true, // Handle external resources
              allowTaint: true, // Allow external images
            }).then((canvas) => {
              const imgData = canvas.toDataURL('image/png');
              const pdf = new jsPDF('p', 'mm', 'a4');
              
              // Margins (10mm on all sides)
              const margin = 10;
              const imgWidth = 210 - margin * 2; // A4 width minus margins
              const imgHeight = (canvas.height * imgWidth) / canvas.width;
              
              // Add title text directly to PDF (alternative approach)
              pdf.setFontSize(19);
              pdf.setTextColor(44, 62, 80); // #2c3e50
              pdf.text(`${currentMonthName} COMMISSION UTILIZATION REPORT`, 105, margin, { align: 'center' }); // Centered
              
              // Add table image with margins
              pdf.addImage(
                imgData, 
                'PNG', 
                margin, 
                margin + 10, // Extra space below title
                imgWidth, 
                imgHeight
              );
          
              pdf.save('commission_utilization_report.pdf');
              
              // Clean up: Remove temporary title and header styling
              title.remove();
              headerRow.style.backgroundColor = '';
              headerRow.style.color = '';
            });
          };

        const getMonthName = (input) => {
            const date = input ? new Date(input) : new Date();
            return date.toLocaleString('default', { month: 'long' });
          };
        //   const currentMonthName = getMonthName(); // No argument → current month
          const customDate = new Date(2025, 7, 11).getTime(); // August 11, 2025 (in ms)
          const augustName = getMonthName(customDate); // "August"


        useEffect(() => {
            setMonthstartms(getCurrentMonthStartInMilliseconds())
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
        
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                      method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }
            if(agent && isAuth){
                getAgentcode()
                setCurrentmonthname(getMonthName())
            }
        },[agent,isAuth])
    
        useEffect(()=>{
            const getExtensions =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUtilizationreport?agent=${agentCode}`,{
                      method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json();
                setExtensions(data)
            }

            const getCommission =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUtilizedCommission?agent=${agentCode}`,{
                      method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                if(data.UtilizedCommission == null){
                    setUtilizedcommission(0)
                }
                else{
                    setUtilizedcommission(data.UtilizedCommission)
                }

                if(data.AvailableCommission == null){
                    setAvailablecommission(0)
                }
                else{
                    setAvailablecommission(data.AvailableCommission)
                }
                
                
            }
    
            if(agentCode && isAuth){
                getExtensions()
                getCommission()
            }
    
        },[agentCode,isAuth])


        function formateDateISO(input){
            if(typeof input === 'string'){
                return input.split('T')[0]
            }
            else if (input instanceof Date){
                return input.toISOString().split('T')[0]
            }
    
            throw new Error('Invalid input: Expected ISO String or Date Object')
        }
        function formatDateToMilliseconds(input) {
            if (typeof input === 'string') {
                // For ISO string, create Date object and get time
                return new Date(input).getTime();
            }
            else if (input instanceof Date) {
                // For Date object, directly get time
                return input.getTime();
            }
            
            throw new Error('Invalid input: Expected ISO String or Date Object');
        }
    
        function formatter(amount) {
            return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          }

          const getCurrentMonthStartInMilliseconds = () => {
            const now = new Date();
            const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            return firstDayOfMonth.getTime();
          };

          const totalCommission = currentPolicies.reduce(
            (sum, policy) => sum + (policy.GrossCommission || 0),
            0
          )
  return (
    <div>
    <div className="page-content">
                <ToastContainer />
               <Breadcrumbs title="Definite Assurance" breadcrumbItem={`COMMISSION UTILIZATION REPORT - ${currentMonthName}`} />
               <Card className="mini-stats-wid">
                   <CardBody>
                   <div className="flt">
                   <div className="mb-4" id='mb'>
                       <Label className="form-label">From date</Label>
                       <Input
                           name="text"
                           className="form-control"
                           placeholder="Search order"
                           type="datetime-local"
                           onChange={handleDateChange}
                           // value={email}

                       />
                       
                   </div>
                   <div className="mb-4" id='mb'>
                       <Label className="form-label">To date</Label>
                       <Input
                           name="text"
                           className="form-control"
                           placeholder="Search order"
                           type="datetime-local"
                           onChange={handleDateChange2}
                           // value={email}

                       />
                       
                   </div>

                   </div>
                       <h5> Total Utilized Commission: {formatter(parseInt(utilizedCommission))} KES</h5>
                       <h5> Available Commission: {formatter(parseInt(availableCommission))} KES</h5>
                       <hr />
                       <button 
                       onClick={exportTableToPDF}
                       style={{ 
                           padding: '8px 16px',
                           background: 'rgb(0, 96, 66)',
                           color: 'white',
                           border: 'none',
                           borderRadius: '4px',
                           cursor: 'pointer'
                       }}
                       >
                       Export to PDF
                       </button>
                         <div className="table-responsive" style={{padding:'10px'}}>
   
   
                       <Table striped bordered hover id="policy-table">
                       <thead>
                           <tr>
                           <th scope="col">#</th>
                           <th scope="col">Note No#</th>                     
                           <th scope="col">Registration</th>
                           <th scope="col">Client</th>
                           <th scope="col">Amount Paid (KES)</th>
                           <th scope="col">Date Posted</th>

                           </tr>
                       </thead>
                       <tbody>
                           {currentPolicies.map((val, index) => {
                           // Calculate the correct index based on current page
                           const globalIndex = indexOfFirstRow + index;
                           
                           if(start == '' && end == ''){
                               if(formatDateToMilliseconds(val.Date_posted) > monthStartMs){
                                   return (
                                       <tr key={val.OID}>
                                       <td>{globalIndex + 1}</td>
                                       <td ><button className="tableButton" value={val.OID} >{val.Document_no}</button></td>
                                       <td>{val.Narration}</td>
                                       <td>{val.Dealer_name}</td>
                                       <td>{formatter(parseInt(val.Amount))}</td>
                                       <td>{formateDateISO(val.Date_posted)}</td>
                                       
                                       </tr>
                                   );

                               }

                           }

                        else{
                           if(formatDateToMilliseconds(val.Date_posted) > start && formatDateToMilliseconds(val.Date_posted) < end ){
                            return (
                                <tr key={val.OID}>
                                <td>{globalIndex + 1}</td>
                                <td ><button className="tableButton" value={val.OID} >{val.Document_no}</button></td>
                                <td>{val.Narration}</td>
                                <td>{val.Dealer_name}</td>
                                <td>{formatter(val.Amount)}</td>
                                <td>{formateDateISO(val.Date_posted)}</td>
                                
                                </tr>
                            );

                           }

                        }

                          
                           })}
                       </tbody>
                       </Table>
   
                       {/* Pagination controls */}
                       <div className="d-flex justify-content-between align-items-center">
                       <div>
                           Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                       </div>
                       <div>
                           <button 
                           className="btn btn-sm btn-outline-primary mx-1"
                           onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                           disabled={currentPage === 1}
                           >
                           Previous
                           </button>
                           
                           {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                           <button
                               key={page}
                               className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                               onClick={() => setCurrentPage(page)}
                           >
                               {page}
                           </button>
                           ))}
                           
                           <button 
                           className="btn btn-sm btn-outline-primary mx-1"
                           onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                           disabled={currentPage === totalPages}
                           >
                           Next
                           </button>
                       </div>
                       </div>
                       </div>
                       
                   </CardBody>
               </Card>
            </div>
</div>
  )
}
